import React, { Component } from 'react'
import { Grid, Row, Col } from 'react-flexbox-grid'
import ImageGallery from 'react-image-gallery'
import { RichText } from 'prismic-reactjs'

import 'react-image-gallery/styles/css/image-gallery.css'
import './style.css'

class Galler extends Component {
  render() {
    return (
      <div>
        <div className="sectionTitle">Rendelőnk</div>
        <Grid className="Gallery">
          <Row>
            <Col xs={12}>
              <ImageGallery
                items={this.props.pictures}
                additionalClass="CustomGallery"
              />
            </Col>
          </Row>
          <Row>
            <Col className="galleryDescription" xs={12}>
              {' '}
              {RichText.render(this.props.description)}
            </Col>
          </Row>
        </Grid>
      </div>
    )
  }
}

export default Galler



// WEBPACK FOOTER //
// ./src/components/Gallery/Gallery.js